module.exports = __webpack_public_path__ + "img/itx-open-box-character.96bb40cb.svg";